let config = null;
let configPromise = null;

///////MB// For Using .json file enable below code /////// 
export const loadConfig = async () => {
  if (!configPromise) {
    configPromise = (async () => {
      try {
        const response = await fetch('/config.json');
        config = await response.json();
      } catch (error) {
        console.error('Failed to load config, using fallback', error);
        config = {
          api: {
            baseUrl: 'http://localhost:3000' // Default fallback
          }
        };
      }
      return config;
    })();
  }
  return configPromise;
};
 
export const getBaseUrl = async () => {
  if (!config) {
    await loadConfig();
  }
  return config.api.baseUrl;
};